export default "Validation page for SMTP.com";